<div class="configurationBannerHeader" (click)="toggleExpansion()">
  <label class="configurationBannerLabel">Performance Results</label>
  <span class="spacer"></span>
  @if (canExpand) {
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  }
</div>
@if (!collapsed) {
  <div class="selectionsWrapper">
    @if (response().errorMessage) {
      <div class="ratingsError">
        {{ response().errorMessage }}
      </div>
    }
    <div class="detailRow">
      <label class="displayLabel">Airflow:</label>
      <label class="displayValue">{{ response().airflow | number: '1.0-2' }}</label>
      <label class="unitLabel">{{ getAirflowUnits() }}</label>
      @if (response().circuitResponse?.outputPower) {
        <span>
          <label class="displayLabel">Power:</label>
          <label class="displayValue">{{ response().circuitResponse.outputPower }}</label>
          <label class="unitLabel">Watts</label>
        </span>
      }
      @if (response().circuitResponse?.horsepowerValue) {
        <span>
          <label class="displayLabel">BHP:</label>
          <label class="displayValue">{{ response().circuitResponse.horsepowerValue }}</label>
        </span>
      }
      @if (response().circuitResponse?.fullLoadAmps) {
        <span>
          <label class="displayLabel">FLA:</label>
          <label class="displayValue">{{ response().circuitResponse.fullLoadAmps }}</label>
        </span>
      }
    </div>
    <div class="detailRow">
      @if (response().primaryCoilResponse) {
        <div class="coilRatingContainer">
          <app-sure-flow-performance-coil-output [response]="response().primaryCoilResponse"
            [isHeat]="(response().primaryCoilResponse?.sensibleCapacity || 0) === 0"
            [fieldLabel]="response().primaryCoilResponse.sensibleCapacity ? 'Cooling Results' : 'Heating Results'" [isMetric]="isMetric()">
          </app-sure-flow-performance-coil-output>
        </div>
      }
      @if (response().secondaryCoilResponse) {
        <div class="coilRatingContainer">
          <app-sure-flow-performance-coil-output [response]="response().secondaryCoilResponse" [isHeat]="true"
            [fieldLabel]="'Heating Results'" [isMetric]="isMetric()">
          </app-sure-flow-performance-coil-output>
        </div>
      }
      <div class="coilRatingContainer">
        @if (response().electricHeatResponse) {
          <div>
            <app-sure-flow-performance-coil-output [response]="response().electricHeatResponse" [isHeat]="true"
              [fieldLabel]="'Electric Heat'" [isMetric]="isMetric()">
            </app-sure-flow-performance-coil-output>
          </div>
        }
      </div>
    </div>
  </div>
}
